import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import {
    errorNotification,
    successNotification,
} from "../../../../../../store/actions";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Progress, Row, UncontrolledTooltip } from "reactstrap";
import { Link } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import DataProtectionSoftwareService from "../../../../apis/DataProtectionSoftwareService";
// icons
import flagOnIcon from "src/modules/data-protection/assets/icons/flag_on.svg";
import flagOffIcon from "src/modules/data-protection/assets/icons/flag_off.svg";
import highPriorityIcon from "src/modules/data-protection/assets/icons/priority-high.png";
import mediumPriorityIcon from "src/modules/data-protection/assets/icons/priority-medium.png";
import lowPriorityIcon from "src/modules/data-protection/assets/icons/priority-low.png";
// styles
import "./style.scss";
// components
import PageBody from "../../../../components/page-body";
import PageContent from "../../../../components/page-content";
import DataProtectionSoftwareCreate from "src/modules/data-protection/pages/admin/software/create";

import OnboardingModal from "../components/onboarding";

import Deletion from "../../software/modal/deletion";

import Spinner from "react-bootstrap/Spinner";
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
    SizePerPageDropdownStandalone,
    PaginationTotalStandalone
} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import overlayFactory from "react-bootstrap-table2-overlay";
import { 
    EMPTY_LIST,
    INTERNATIONAL_DATE_FORMAT
} from "src/common/constants";
import CommonService from "src/modules/data-protection/apis/CommonService";
import { Assets_STATUS_LIST } from "../../../../constants"
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'react-bootstrap';
import FilteringComponent from "./filtering-component";
import ExportExcelButton from "../components/export-excel-button";
import DateUtils from "src/services/utils/DateUtils";

const DataProtectionSoftwareList = (props) => {
    const { t, tab } = props;
    const dateUtils = new DateUtils();

    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);

    const [onboardingModal, setOnboardingModal] = useState(false);
    const [isOnboardingStarted, setIsOnboardingStarted] = useState(false);

    const [moreActionsDropDownOpen, setMoreActionsDropDownOpen] = useState(false);

    const toggleMoreActionsDropDown = () => setMoreActionsDropDownOpen(!moreActionsDropDownOpen)

    const [tableFilters, setTableFilters] = useState({
        pageIndex: 1,
        pageSize: 25,
        sortField: null,
        sortOrder: null,
        status: null,
        flag: null,
        owner: null,
        service: undefined
    });

    const handleOnboardingClick = () => {
        setOnboardingModal(true);
    };

    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            // Select all ids
            const allIds = softwares.assets.map((software) => software.id);
            setSelectedIds(allIds);
        } else {
            // Deselect all
            setSelectedIds([]);
        }
    };

    const [softwares, setSoftwares] = useState([]);

    const [showDeletionModal, setDeletionModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [deletionComplete, setDeletionComplete] = useState(false);

    const tableColumns = [
        {
            dataField: "checkbox",
            text: (
                <input
                    type="checkbox"
                    className="custom-checkbox"
                    checked={
                        selectedIds.length > 0 && selectedIds.length === softwares.assets.length
                    }
                    onChange={handleSelectAllChange}
                    style={{ marginLeft: 'auto', marginRight: 'auto' }} // Center the checkbox
                />
            ),
            sort: false,
            key: 1,
            formatter: (cellContent, row) => {
                return (
                    <input
                        type="checkbox"
                        className="custom-checkbox"
                        checked={selectedIds.includes(row.id)}
                        onChange={() => handleCheckboxChange(row.id)}
                    />
                );
            },
            style: {
                width: "1%",
                textAlign: "center",
            },
        },
        {
            key: 2,
            dataField: "financial_risk",
            text: props.t("Risk Rating"),
            sort: false,
            formatter: (cellContent, { answer_completion_percent }) => {
                if(parseInt(answer_completion_percent) < 100){
                    return (
                        <span
                            style={{ backgroundColor: '#b1b1b1' }}
                            className="risk-rate mx-2"
                        ></span>
                    )
                }

                return (
                    <span
                        style={{ backgroundColor: `#${cellContent.color}` }}
                        className="risk-rate mx-2"
                    ></span>
                );
            },
            style: {
                width: "80px",
                textAlign: "right",
            }
        },
        {
            dataField: "secondary_id",
            text: t("Assets ID"),
            sort: false,
            key: 4,
            style: {
                width: "80px",
            }
        },
        {
            dataField: "service",
            text: t("Service"),
            sort: true,
            key: 3,
            formatter: (cell, row) => {
                const isDeleted = row?.status === "DELETED";

                return (
                    <Link
                        to={isDeleted ? "#" : `softwares/${row.id}`}
                        className={`text-break text-wrap text-truncate text-capitalize text-left ${isDeleted ? 'disabled-link' : ''}`}
                        onClick={e => isDeleted && e.preventDefault()}
                        style={isDeleted ? { cursor: 'not-allowed', } : {}}
                    >
                        {row.service}
                    </Link>
                );
            },
            style: {
                width: "120px",
            }
        },
        {
            dataField: "version",
            text: t("Version"),
            sort: true,
            key: 5,
            style: {
                width: "80px",
            }
        },
        {
            dataField: "os",
            text: t("Operating System"),
            sort: true,
            key: 6,
            style: {
                width: "120px",
            },
            formatter: (_cellContent, { operating_system_name }) => {
                return operating_system_name;
            }
        },
        {
            dataField: "assignedAnalyst",
            text: t("Assigned Analyst"),
            sort: true,
            key: 7,
            formatter: (cell, row) => {
                return (
                    <p>{row.analyst_assigned_name ? row.analyst_assigned_name : "---"}</p>
                );
            },
            style: {
                width: "120px",
            }
        },
        {
            key: 8,
            dataField: "createdAt",
            sort: true,
            text: props.t('Created On'),
            formatter: (_cellContent, { created_at }) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            created_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                );
            },
            style: {
                width: "80px",
            }
        },
        {
            key: 9,
            dataField: "updatedAt",
            sort: true,
            text: props.t('Updated On'),
            formatter: (_cellContent, { updated_at }) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            updated_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                );
            },
            style: {
                width: "80px",
            }
        },
        {
            dataField: "answer_completion_percent",
            text: `${t("PA Completion")} (%)`,   
            sort: false,
            key: 10,
            style: {
                width: '120px'
            },
            formatter: (cell, row) => {
                return (
                    <div className="d-flex flex-column align-items-center">
                        <div>
                            <span 
                                style={{
                                    fontSize: "10px"
                                }}
                            >{cell}%</span>
                            <i 
                                className="ri-information-line align-middle ms-1" 
                                id={`pa-percent-tooltip-${row.id}`}
                            />
                            <UncontrolledTooltip
                                placement="top"
                                target={`pa-percent-tooltip-${row.id}`}
                                trigger="hover"
                            >
                                {t(
                                    "Indicates how much of the Processing Activities questionnaire has been completed for this software."
                                )}
                            </UncontrolledTooltip>
                        </div>
                        <Progress 
                            value={cell} 
                            max={100} 
                            color="success"
                            style={{ width: "100%" }}
                        />
                    </div>
                );
            }
        },
        {
            dataField: "flag",
            text: t("Flag"),
            sort: true,
            key: 11,
            formatter: (cell, row) => handleRenderFlag(row),
            style: {
                width: "80px",
            }
        },
        {
            dataField: "priority",
            text: t("Priority"),
            sort: true,
            key: 12,
            formatter: (cell, row) => {
                return <p>{handleRenderPriority(row.priority)}</p>;
            },
            style: {
                width: "80px",
                textAlign: "center",
            }
        },
        {
            dataField: "status",
            text: t("Status"),
            sort: true,
            key: 13,
            formatter: (cell, row) => {
                return (
                    <p >
                        {handleRenderStatus(row.status)}
                    </p>
                );
            },
            style: {
                width: "80px",
            }
        },
        {
            dataField: "empty",
            text: "",
            sort: false,
            key: 14,
            formatter: (cellContent, row) => {
                return row.status !== "DELETED" ? (
                    <div className="text-danger text-truncate text-capitalize text-center d-flex justify-content-center remove">
                        <a
                            onClick={() => onRemoveClick(row.id)}
                            style={{ cursor: "pointer" }}
                        >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                        </a>
                    </div>
                ) : (
                    <span className="text-danger text-truncate text-capitalize text-center d-flex justify-content-center remove">
                        {t("Deleted")}
                    </span>
                );
            },
            style: {
                width: "80px",
                textAlign: "center",
            }
        },
    ];

    const handleFetchSoftwareListQuery = useQuery({
        queryKey: [
            "data-protection-softwares-list", 
            tableFilters,
            tab
        ],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.list({
                ...tableFilters,
                status: tab === "deletion-protocol" ? "DELETED" : tableFilters.status,
            });
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching softwares."), {
                type: "error",
            });
        },
    });

    const handleFetchSoftwaresFromCloudQuery = useQuery({
        queryKey: ["gdpr-fetch-softwares-from-cloud-query"],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.SoftwareFetch();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching softwares."), {
                type: "error",
            });
        },
        onSuccess: () => {
            handleFetchSoftwareListQuery.refetch();
        }
    });

    const handleFetchUsersListQuery = useQuery({
        queryKey: ["data-protection-users-list"],
        queryFn: async () => {
            const service = CommonService.getInstance();
            return await service.analystAdminsAndAnalysts();
        },
        cacheTime: 0,
        refetchOnWindowFocus: true,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching softwares."), {
                type: "error",
            });
        },
    });

    const toggleSoftwareFlagMutation = useMutation({
        mutationFn: async ({ softwareId }) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.toggleFlag({
                softwareId: softwareId,
            });
        },
        onSuccess: () => {
            toast(t("Software flag status successfully changed."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while changing flag status."), {
                type: "error",
            });
        },
        onMutate: ({ softwareId }) => {
            setSoftwares({
                ...softwares,
                assets: softwares.assets.map((software) => {
                    if (software.id === softwareId) {
                        return {
                            ...software,
                            flagIsUpdating: true,
                        };
                    }
                    return software;
                }),
            });
        },
    });

    const onApproveSelection = useMutation({
        mutationFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.approveSelection({
                softwareIds: selectedIds,
            });
        },
        onSuccess: () => {
            toast(t("Selected softwares are approved"), {
                type: "success",
            });
            handleFetchSoftwareListQuery.refetch();
        },
        onError: () => {
            toast(t("An error occurred while approving selected softwares."), {
                type: "error",
            });
        },
    });

    const usersList = useMemo(() => {
        return (handleFetchUsersListQuery.data || []).map((u) => {
            return {
                value: u.id,
                label: u.first_name + " " + u.last_name,
            };
        });
    }, [ handleFetchUsersListQuery.data ]);

    const NoDataIndication = () =>
        handleFetchSoftwareListQuery.isFetched &&
            !handleFetchSoftwareListQuery.length ? (
            <div className="alert m-0" role="alert">
                <p
                    style={{
                        textAlign: "center",
                        marginBottom: 0,
                    }}
                >
                    {t(EMPTY_LIST)}
                </p>
            </div>
        ) : (
            <></>
        );

    const handleTableChange = (type, data) => {
        switch (type) {
            case "pagination":
                const { page, sizePerPage } = data
                setTableFilters({
                    ...tableFilters,
                    pageIndex: page,
                    pageSize: sizePerPage,
                });
                break;

            case 'sort': {
                const { sortField, sortOrder } = data
                setTableFilters({
                    ...tableFilters,
                    pageIndex: 1,
                    sortField: sortField,
                    sortOrder: sortOrder,
                });
                break
            }
            default:
                return false;
        }
    };

    const onRemoveClick = (id) => {
        setSelectedId(id);
        setDeletionModal(true);
    };

    const toggleAssetFlag = (asset) => {
        toggleSoftwareFlagMutation.mutate(
            {
                softwareId: asset.id,
            },
            {
                onSuccess: () => {
                    setSoftwares({
                        ...softwares,
                        assets: softwares.assets.map((software) => {
                            if (software.id === asset.id) {
                                return {
                                    ...software,
                                    flag: !asset.flag,
                                };
                            }
                            return software;
                        }),
                    });
                },
            }
        );
    };

    const handleRenderFlag = (asset) => {
        return (
            <Button
                onClick={() => toggleAssetFlag(asset)}
                size="sm"
                outline
                color="transparent"
                className="border-0" 
            >
                {asset.flagIsUpdating === true ? (
                    <Spinner 
                        animation="border" 
                        variant="secondary" 
                        size="sm" 
                        className="me-1"
                    />
                ) : (
                    <img
                        src={asset.flag ? flagOnIcon : flagOffIcon}
                        alt="Flag Icon"
                        className="me-1"
                    />
                )}
                <i 
                    className="ri-information-line" 
                    id={`flagInfoIcon-${asset.id}`}
                />
                <UncontrolledTooltip
                    placement="top"
                    target={`flagInfoIcon-${asset.id}`}
                    trigger="hover"
                >
                    {t(
                        "Flagged software contains risk issues and may require further attention. Unflagged software is considered safe, as no critical risks have been identified at this time."
                    )}
                </UncontrolledTooltip>
            </Button>
        );
    };

    const handleRenderPriority = (priority) => {
        switch (priority) {
            case "HIGH": {
                return (
                    <div className="priority text-capitalize">
                        <span className="priority-icon d-flex align-items-center justify-content-center">
                            <img
                                src={highPriorityIcon}
                                alt="Flag Icon"
                                className="object-fit-contain d-inline-block mw-100"
                            />
                        </span>
                        {t(priority.toLowerCase())}
                    </div>
                );
            }
            case "MEDIUM": {
                return (
                    <div className="priority text-capitalize">
                        <span className="priority-icon d-flex align-items-center justify-content-center">
                            <img
                                src={mediumPriorityIcon}
                                alt="Flag Icon"
                                className="object-fit-contain d-inline-block mw-100"
                            />
                        </span>
                        {t(priority.toLowerCase())}
                    </div>
                );
            }
            case "LOW": {
                return (
                    <div className="priority text-capitalize">
                        <span className="priority-icon d-flex align-items-center justify-content-center">
                            <img
                                src={lowPriorityIcon}
                                alt="Flag Icon"
                                className="object-fit-contain d-inline-block mw-100"
                            />
                        </span>
                        {t(priority.toLowerCase())}
                    </div>
                );
            }
            default: {
                return (
                    <div className="priority text-capitalize">
                        <span className="priority-icon d-flex align-items-center justify-content-center">
                            <img
                                src={lowPriorityIcon}
                                alt="Flag Icon"
                                className="object-fit-contain d-inline-block mw-100"
                            />
                        </span>
                        {t(priority.toLowerCase())}
                    </div>
                )
            }
        }
    };

    const handleRenderStatus = (status) => {
        const statusData = Assets_STATUS_LIST[status];

        if (!statusData) {
            return "---";
        }

        return (
            <div
                style={{
                    fontSize: "10px",
                    fontWeight: 700,
                    padding: "3px 8px",
                    background: statusData.backgroundColor,
                    opacity: statusData?.opacity || 1,
                    color: "#1D1D1D",
                    borderRadius: '7px',
                    whiteSpace: 'nowrap',
                    width: 'fit-content'
                }}
                className={"dt-task-status "}
            >
                {t(statusData.title)}
            </div>
        );
    };

    const handleDownloadCSV = async (fileName) => {
        try {
            const service = DataProtectionSoftwareService.getInstance();
            const result = await service.downloadCSV();
            const fileData = new Uint8Array(result);
            const blob = new Blob([fileData], { type: "application/octet-stream" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            // document.body.removeChild(link);
        } catch (error) {
            console.log(error)
            toast(props.t("An error occurred while downloading CSV."), {
                type: "error",
            });
            console.error("failed to download csv: ", error);
        }
    };

    const handleDownloadTemplate = async (fileName) => {
        try {
            const service = DataProtectionSoftwareService.getInstance();
            const result = await service.downloadTemplate();
            const fileData = new Uint8Array(result);
            const blob = new Blob([fileData], { type: "application/octet-stream" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            // document.body.removeChild(link);
        } catch (error) {
            console.log(error)
            toast(props.t("An error occurred while downloading template."), {
                type: "error",
            });
            console.error("failed to download template: ", error);
        }
    };

    const handleCheckboxChange = (id) => {
        setSelectedIds((currentIds) => {
            if (currentIds.includes(id)) {
                // Remove id from the array if it is already included
                return currentIds.filter((currentId) => currentId !== id);
            } else {
                // Add id to the array if it is not included
                return [...currentIds, id];
            }
        });
    };

    const handleFilterChange = useCallback((newFilters) => {
        setTableFilters((currentFilters) => {
            return {
                ...currentFilters,
                ...newFilters
            }
        });
    }, []);

    useEffect(() => {
        if (deletionComplete) {
            handleFetchSoftwareListQuery.refetch();
            setDeletionComplete(false);
        }
    }, [deletionComplete]);

    useEffect(() => {
        if (handleFetchSoftwareListQuery.data) {
            setSoftwares(handleFetchSoftwareListQuery.data);
        }

    }, [handleFetchSoftwareListQuery.data]);

    useEffect(() => {
        handleFetchSoftwareListQuery.refetch();
    }, []);

    return (
        <PageContent classNames="data-protection-software-list-page pt-4 mt-3">
            {/* Create Modal */}
            <DataProtectionSoftwareCreate
                createModalOpen={createModalOpen}
                fetchData={() => handleFetchSoftwareListQuery.refetch()}
                toggleModal={() => setCreateModalOpen(!createModalOpen)}
            />

            {/* Onboarding Modal */}
            {onboardingModal && <OnboardingModal
                modal={onboardingModal}
                setModal={setOnboardingModal}
                isOnboardingStarted={isOnboardingStarted}
                setIsOnboardingStarted={setIsOnboardingStarted}
            />}

            <Container fluid>
                {/* page header */}
                <Row>
                    <Col>
                        <div
                            className='d-flex justify-content-between align-items-center mb-3 mt-3'
                        >
                            <Button
                                outline
                                color="primary"
                                disabled={!selectedIds?.length}
                                onClick={() => onApproveSelection.mutate()}
                            >
                                {props.t("Approve Selected")}
                            </Button>

                            <div className="d-flex">
                                <FilteringComponent
                                    onChange={handleFilterChange}
                                    fetchOwnersQuery={handleFetchUsersListQuery}
                                    tab={tab}
                                />

                                {tab !== 'deletion-protocol' && (
                                    <Dropdown
                                        isOpen={moreActionsDropDownOpen}
                                        toggle={toggleMoreActionsDropDown}
                                    >
                                        <DropdownToggle
                                            caret
                                            variant="outline-secondary"
                                            outline
                                        >
                                            {props.t('Actions')}
                                        </DropdownToggle>
                                        <DropdownMenu
                                            className="dropdown-menu-end"
                                        >
                                            <DropdownItem
                                                onClick={() => setCreateModalOpen(!createModalOpen)}
                                            >
                                                <i className="ri-add-line align-middle me-2" />
                                                {props.t("Add New Asset")}
                                            </DropdownItem>

                                            <DropdownItem
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                    handleFetchSoftwaresFromCloudQuery.refetch()
                                                }}
                                            >
                                                <div>
                                                    <i className="ri-download-cloud-2-line align-middle me-2" />
                                                    {props.t("Fetch Software")}
                                                </div>
                                            </DropdownItem>

                                            <DropdownItem
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                    handleDownloadCSV(
                                                        `Software List - ${new Date().toDateString()}.xlsx`
                                                    )
                                                }}
                                            >
                                                <div>
                                                    <i className="ri-file-copy-line align-middle me-2" />
                                                    {props.t("Copy of the software assets")}
                                                </div>
                                            </DropdownItem>

                                            <DropdownItem
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                }}
                                            >
                                                <ExportExcelButton 
                                                    filters={tableFilters}
                                                />
                                            </DropdownItem>

                                            <DropdownItem
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                    handleDownloadTemplate(
                                                        `Software List - ${new Date().toDateString()} - template.xlsx`
                                                    )
                                                }}
                                            >
                                                <div>
                                                    <i className="ri-download-2-line align-middle me-2" />
                                                    {props.t("Download Template")}
                                                </div>
                                            </DropdownItem>

                                            <DropdownItem
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                    handleOnboardingClick()
                                                }}
                                            >
                                                <div>
                                                    <i className="ri-upload-2-line align-middle me-2" />
                                                    {props.t("Upload Excel")}
                                                </div>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                 )}
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* page body */}
                <PageBody>
                    <Row>
                        <Col sm="12">
                            <PaginationProvider
                                pagination={paginationFactory({
                                    custom: true,
                                    page: tableFilters.pageIndex,
                                    sizePerPage: tableFilters.pageSize,
                                    totalSize: handleFetchSoftwareListQuery.data?.itemsCount || 0,
                                    withFirstAndLast: false,
                                    alwaysShowAllBtns: true,
                                    prePageText: (
                                        <span>
                                            <i className="ri-arrow-left-s-line"></i> {t("Back")}
                                        </span>
                                    ),
                                    nextPageText: (
                                        <span>
                                            {t("Next")} <i className="ri-arrow-right-s-line"></i>
                                        </span>
                                    ),
                                    prePageTitle: t("Pre page"),
                                    firstPageTitle: t("Next page"),
                                    sizePerPageList: [
                                        {
                                            text: "25",
                                            value: 25,
                                        },
                                        {
                                            text: "50",
                                            value: 50,
                                        },
                                    ],
                                    showTotal: false,
                                    paginationTotalRenderer: (from, to, size) => {
                                        return (
                                            <span className="react-bootstrap-table-pagination-total">
                                                {`${props.t('Total Items')} ${size}`}
                                            </span>
                                        )
                                    },
                                    hideSizePerPage: false,
                                })}
                            >
                                {({ paginationProps, paginationTableProps }) => (
                                    <React.Fragment>
                                        <Row>
                                            <Col sm="12">
                                                <BootstrapTable
                                                    remote={{
                                                        pagination: true,
                                                        filter: false,
                                                        sort: true,
                                                        cellEdit: false,
                                                        search: false,
                                                    }}
                                                    loading={
                                                        handleFetchSoftwareListQuery.isFetching ||
                                                        handleFetchSoftwareListQuery.isLoading
                                                    }
                                                    overlay={overlayFactory({
                                                        spinner: (
                                                            <Spinner
                                                                animation="border"
                                                                variant="primary"
                                                                size="md"
                                                            />
                                                        ),
                                                        text: "Loading...",
                                                    })}
                                                    onTableChange={handleTableChange}
                                                    defaultSorted={[]}
                                                    keyField={"id"}
                                                    responsive
                                                    bordered={false}
                                                    data={softwares?.assets || []}
                                                    striped={false}
                                                    columns={tableColumns}
                                                    wrapperClasses="table-responsive"
                                                    classes={"table tpdd-table"}
                                                    headerWrapperClasses={"thead-light"}
                                                    style={{
                                                        overflowX: "auto",
                                                    }}
                                                    noDataIndication={() => <NoDataIndication />}
                                                    {...paginationTableProps}
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm="12">
                                                <div className="tpdd-pagination-style-1">
                                                    <PaginationTotalStandalone
                                                        {...paginationProps}
                                                    />

                                                    <div>
                                                        <PaginationListStandalone
                                                            {...paginationProps}
                                                        />

                                                        <SizePerPageDropdownStandalone
                                                            {...paginationProps}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                )}
                            </PaginationProvider>
                        </Col>
                    </Row>
                </PageBody>
            </Container>
            {/* Deletion Modal */}
            {usersList?.length ? (
                <Deletion
                    t={t}
                    modal={showDeletionModal}
                    setModal={setDeletionModal}
                    users={usersList}
                    id={selectedId}
                    setDeletionComplete={setDeletionComplete}
                />
            ) : null}
        </PageContent>
    );
};

export default withNamespaces()(
    withRouter(
        connect(null, {
            errorNotification,
            successNotification,
        })(memo(DataProtectionSoftwareList))
    )
);
